import React from "react";
import PropTypes from "prop-types";
import NoIndex from "../NoIndex";

import styles from "./printing.module.scss";

function Printing({
  title,
  content: {printingInfo},
  seo: {printingInfo: seoPrintingInfo},
  withoutTitle
}) {
  return (
    <NoIndex>
      <div className={styles.root}>
        {!withoutTitle && <h2 className={styles.title}>{title}</h2>}
        <div
          className={styles.text}
          dangerouslySetInnerHTML={((__html) => ({__html}))(
            seoPrintingInfo || printingInfo
          )}
        />
      </div>
    </NoIndex>
  );
}

Printing.propTypes = {
  title: PropTypes.string,
  content: PropTypes.object,
  seo: PropTypes.object,
  withoutTitle: PropTypes.bool
};

export default Printing;
